import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import AppShell from '../components/AppShell';
import FormTab from '../components/dash/FormTab';
import { API, authHeaders } from '../lib/auth';
import { useMe, useFlash } from '../lib/useMe';

export default function MyFormPage() {
  const [me] = useMe();
  const flash = useFlash();
  const [subs, setSubs] = useState([]);
  const loadSubs = useCallback(() => axios.get(`${API}/user/submissions`, { headers: authHeaders() }).then(({ data }) => setSubs(data)).catch(() => {}), []);
  useEffect(() => { if (me) loadSubs(); }, [me, loadSubs]);

  if (!me) return <AppShell title="My Form"><p style={{ color: 'var(--muted)' }}>Loading…</p></AppShell>;
  return (
    <AppShell title="My Form" subtitle="Everything you shared in your Krysha matchmaking form." testid="my-form-page">
      <FormTab subs={subs} loadSubs={loadSubs} flash={flash} />
    </AppShell>
  );
}
